declare namespace $ {

	export class $bog_builderui_avatar extends $mol_image {
	}
	
}

//# sourceMappingURL=avatar.view.tree.d.ts.map